import React from 'react';
import {
  Navigation,
  NavigationContainer,
  NavigationItem,
  NavigationItemsContainer,
  NavigationLineSeparator,
  NavigationSubscriptionButton
} from './UbisoftPlusNavigationStyle';
import { ReactComponent as UbisoftPlusLogo } from '../../assets/ubisoft_plus_logo.svg';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import SubscriptionButton from '../SubscriptionButton/SubscriptionButton';
import { useSelector } from 'react-redux';
import { IState } from '../../types/store/reducer';
import { getNavigationPageLink } from '../../utils';

interface INavigationProps {
  context?: IContent;
}

const UbisoftPlusNavigation = ({ context }: INavigationProps) => {
  let app = useSelector(( state: IState) => state.app);
  return (
    <Navigation>
      <NavigationContainer>
        <UbisoftPlusLogo className={'navigation-logo'} />
        <NavigationItemsContainer>
          {Object.keys(context.navigation).map((item: string, index) => {
            let navigationItem = <NavigationItem className={'bolden-text'} key={`nav-${item}`} href={getNavigationPageLink(item)} isCurrentPage={item === 'landing'}  isLastItem={Object.keys(context.navigation).length - 1 === index}
            >{context.navigation[item]}</NavigationItem>
            //Separated between multiple ifs since we don't want to see the cloud gaming list logo flash
            if (item === 'cloud') {
              if (app.windowVariablesInitialised) {
                if (app.lunaAvailable || app.stadiaAvailable) {
                  return navigationItem;
                }
              }
            } else {
              return navigationItem;
            }
          })}
        </NavigationItemsContainer>
        <NavigationSubscriptionButton>
          <SubscriptionButton idToAttach={'navigationSubscription'} />
        </NavigationSubscriptionButton>
      </NavigationContainer>
    </Navigation>
  );
};

export default withContent(UbisoftPlusNavigation);